module.exports = __webpack_public_path__ + "img/DK81753512.d26b953b.png";